{
  "nav": {
    "aria": "Main menu",
    "howItWorks": "How the AI works",
    "pricing": "Pricing",
    "faq": "FAQ",
    "toApp": "Go to dashboard",
    "toAppShort": "Dashboard",
    "login": "Sign in",
    "startFree": "Start free"
  },
  "hero": {
    "headline": "Let AI answer customers with your shop's real prices and stock",
    "sub": "Connect LINE OA, Facebook and Instagram, and the AI answers questions, sends product photos, sums up orders and sends your PromptPay QR, day and night. Anything that needs a person goes straight to your team.",
    "cta": "Start 7-day free trial",
    "terms": "No credit card · THB 699/month after the trial",
    "worksWith": "Works with"
  },
  "scene": {
    "aria": "Example chat: at {{time}} a customer asks about a linen shirt; the AI replies with price and stock, sends product photos, then sums up a THB {{total}} order with a PromptPay QR",
    "shopName": "Baan Linen",
    "status": "Shop closed · AI replying",
    "aiLabel": "AI",
    "customer1": "Is the cream linen shirt still available in M?",
    "ai1": "Yes, 3 left in size M at THB 590. Here are some photos.",
    "productName": "Linen shirt · Cream",
    "productStock": "Size M · 3 left",
    "customer2": "I'll take one. Same address as last time.",
    "ai2": "Here's your order. Scan the PromptPay QR to pay.",
    "orderTitle": "Order summary",
    "orderItem": "Linen shirt, cream, M × 1",
    "orderShipping": "Shipping",
    "orderTotal": "Total",
    "orderPay": "Pay with PromptPay"
  },
  "walkthrough": {
    "title": "Watch the AI close one sale, start to finish",
    "sub": "Every step uses your own shop data: catalogue, shipping rates and payment accounts.",
    "steps": {
      "catalogue": {
        "title": "Search your catalogue",
        "body": "Reads the price and stock of every size and colour you list. Prices come from your catalogue, and the system works out the total."
      },
      "photos": {
        "title": "Send product photos",
        "body": "Picks photos from your listings and sends them in the chat."
      },
      "customer": {
        "title": "Remember the customer",
        "body": "Saves name, phone and address to your CRM, so next time \"same address\" is enough."
      },
      "order": {
        "title": "Sum up the order",
        "body": "The system prices the order and shipping. The customer confirms it, or an admin approves it first."
      },
      "payment": {
        "title": "Send your PromptPay QR",
        "body": "Sends your QR code and bank details so the customer can pay right away."
      },
      "handoff": {
        "title": "Hand off to your team",
        "body": "If the customer asks for a person or the question goes beyond what it knows, the AI says so and passes the chat to your team."
      }
    },
    "soldOut": "Sold out",
    "left": "{{count}} left",
    "colours": ["Cream", "Sage", "Charcoal"],
    "customerName": "Mali Wongyai",
    "customerPhone": "081-xxx-4521",
    "customerAddress": "12/3 Nimmanhaemin Rd, Suthep, Mueang, Chiang Mai 50200",
    "savedToCrm": "Saved to CRM",
    "promptPay": "PromptPay",
    "account": "Baan Linen · Kasikornbank",
    "handoffMessage": "Can I talk to someone? I need to change the delivery address.",
    "handoffTag": "Needs a human"
  },
  "controls": {
    "title": "You decide what the AI is allowed to do",
    "sub": "Set it up once on the AI assistant page and change it whenever you like.",
    "points": [
      {
        "title": "Tone and language",
        "body": "Friendly, formal or playful, in Thai or English to match the customer, plus your own wording, such as how to address customers."
      },
      {
        "title": "Order permissions",
        "body": "Let customers confirm orders themselves, or have an admin approve every order before the QR goes out."
      },
      {
        "title": "What the AI knows",
        "body": "Your FAQ, shipping and return policies, and the delivery fee and free-shipping rule from your delivery settings."
      },
      {
        "title": "Switch it off when you like",
        "body": "Choose which channels the AI answers and switch it off in any chat. When your team replies in a chat, the AI steps back there on its own."
      }
    ],
    "notesValue": "Address customers as \"Dear customer\""
  },
  "clock": {
    "title": "You can answer chats 9 hours a day. The AI covers all 24.",
    "sub": "Late-night messages get an answer within seconds. In the morning you see orders waiting to be packed instead of a backlog of chats.",
    "aria": "24-hour diagram: you answer chats from 09:00 to 18:00, the AI answers around the clock",
    "you": "You",
    "youHours": "09:00–18:00",
    "ai": "AI",
    "aiHours": "Around the clock",
    "markers": [
      {
        "time": "23:40",
        "text": "How long to ship to Chiang Mai?"
      },
      {
        "time": "02:14",
        "text": "Is size M still available?"
      },
      {
        "time": "06:05",
        "text": "Payment sent!"
      }
    ]
  },
  "team": {
    "title": "As the shop grows, the whole team works from one inbox",
    "sub": "The AI takes the bulk of the chats; your team handles the ones that need a person.",
    "points": [
      "LINE OA, Facebook and Instagram chats in one inbox",
      "A \"Needs a human\" tab collects every chat the AI hands off",
      "3 admin seats with per-person permissions, more available",
      "Customer profile, chat history and orders next to the conversation",
      "Payment and delivery status for every order"
    ]
  },
  "pricing": {
    "title": "One price, everything included",
    "sub": "Try it free for 7 days, then decide. Renew only when you want to.",
    "term": "Monthly plan",
    "perMonth": "/ month",
    "vat": "VAT included · one payment per cycle",
    "cta": "Choose this plan",
    "trial": "Try {{days}} days free first",
    "noCard": "No credit card required",
    "features": [
      "AI assistant that replies automatically (daily usage quota)",
      "Connect LINE OA, Facebook and Instagram",
      "3 admin seats, add more later",
      "Products, orders and delivery in one place",
      "Unlimited CRM customers with full chat history",
      "Thai-language support via LINE OA"
    ],
    "benefits": ["Pay for your plan with PromptPay", "No contract, no per-message fees"]
  },
  "faq": {
    "title": "Frequently asked questions",
    "items": [
      {
        "question": "Will the AI make mistakes or invent prices?",
        "answer": "The AI reads prices and stock from your own products, and order totals and shipping are calculated by the system, not the AI. When a question goes beyond what it knows, the AI tells the customer and passes the chat to your team."
      },
      {
        "question": "Can I turn the AI off, or let my team answer some chats?",
        "answer": "Yes. Choose which channels the AI answers, turn it off entirely on the AI assistant page, and pause it chat by chat from the inbox."
      },
      {
        "question": "Is AI usage unlimited?",
        "answer": "Your plan includes a daily AI usage quota. You can see how much you've used on the Usage tab of the AI assistant page."
      },
      {
        "question": "Does it work with LINE OA Premium?",
        "answer": "Yes. Both Free and Premium accounts work through the Messaging API."
      },
      {
        "question": "Where are customer data and chats stored?",
        "answer": "Chats and customer records are on Google Cloud; photos and files from chats are on Cloudflare. Both are encrypted in transit and at rest. You can request deletion of all your data under our privacy policy."
      },
      {
        "question": "Do you charge per message?",
        "answer": "No. It's a flat monthly price, with no per-message or per-customer fees."
      },
      {
        "question": "Can I add admin seats mid-cycle?",
        "answer": "Yes. Seats are prorated for the days left in your current billing cycle."
      },
      {
        "question": "Is there a contract? When can I cancel?",
        "answer": "No contract. Cancel renewal any time on the billing page and keep using the service until the end of the current cycle. Fees already paid are non-refundable."
      },
      {
        "question": "Is there Thai-language support?",
        "answer": "Yes. Contact us through LINE OA @sightorder during business hours."
      }
    ]
  },
  "finalCta": {
    "title": "Let the AI start answering your customers tonight",
    "sub": "7-day free trial, no credit card.",
    "button": "Start 7-day free trial"
  },
  "footer": {
    "tagline": "AI chat replies and sales for Thai online shops",
    "productHeading": "Product",
    "supportHeading": "Support",
    "legalHeading": "Legal",
    "howItWorks": "How the AI works",
    "pricing": "Pricing",
    "terms": "Terms of service",
    "privacy": "Privacy policy"
  },
  "mockup": {
    "conversations": ["Nat", "K. Bell", "Tarn", "Beam"],
    "messages": ["Hi there", "Can I add 2 more boxes of cookies?", "Sure thing ❤️", "Payment sent 🙏"],
    "composerPlaceholder": "Type a message…",
    "customerName": "Nat",
    "customerTag": "VIP · Regular customer",
    "statSpend": "Spent",
    "statConversations": "Conversations",
    "statSince": "Since",
    "statSinceValue": "Mar 2025"
  }
}
